import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SliderSimple',
  props: {
    disabled: { type: Boolean },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    value: { default: 0 },
    trackColor: { default: "elements" },
    trackFillColor: { default: "primary" }
  },
  emits: ["end", "input", "start"],
  setup(__props: any, { emit }: { emit: ({
  (e: "end", value?: number): void;
  (e: "input", value?: number): void;
  (e: "start", value?: number): void;
}), expose: any, slots: any, attrs: any }) {






function updateValue(value: number) {
  emit("input", value);
}

function onStart(value: number) {
  emit("start", value);
}

function onEnd(value: number) {
  emit("end", value);
}

return { __sfc: true,emit, updateValue, onStart, onEnd }
}

})